"use client";

import { useTheme } from "#/hooks/useTheme";

export type LoadingGemProps =
  | {
      variant?: "rotate";
      quality?: "high" | "low";
      visible?: boolean;
      className?: string;
    }
  | {
      variant: "tilt";
      quality?: "high";
      visible?: boolean;
      className?: string;
    }
  | {
      variant: "pink";
      quality?: "high";
      visible?: boolean;
      className?: string;
    };

export const LoadingGem: React.FC<LoadingGemProps> = ({
  variant = "rotate",
  quality = "high",
  visible = true,
  className,
}) => {
  const { theme } = useTheme();

  if (!visible) return null;

  return (
    <video loop muted autoPlay playsInline key={theme} className={className}>
      <source
        type="video/mp4"
        src={`/videos/gem-${variant}-${theme}-${quality}.mp4`}
      />
      Your browser does not support the video tag.
    </video>
  );
};
